<script>
    import {mapGetters, mapState, mapActions} from 'vuex';
    import {payMinMaxLabel, getSearchBaseUrl, slugify} from '@/utils/helpers';

    export default {

        computed: {

            showCompanyLogo() {
                return window?.afConfig?.show_company_logo === 'Yes';
            },

            ...mapState({
                $_job: state => state.job.job,
            }),

            ...mapGetters('job', {
                $_jobTitle: 'jobTitle',
                $_companyName: 'companyName',
                $_primaryCompanyName: 'primaryCompanyName',
                $_locationLabel: 'locationLabel',
                $_categoryLabel: 'categoryLabel',
                $_occupationLabel: 'occupationLabel',
                $_classifications: 'classifications',
                $_jobBody: 'jobBody',
                $_jobTypeLabel: 'jobTypeLabel',
                $_postedAt: 'postedAt',
                $_isPrivateListing: 'isPrivateListing',
            }),

            getMinMaxLabel() {
                return payMinMaxLabel(this.$_job, this.$t('global.currency_symbol'));
            },


            getLocationLink() {
                return `${getSearchBaseUrl()}/in-${this.$_job.location_slug}/`;
            },

        },

        created() {
            this.$_saveQueryString();
        },

        methods: {
            ...mapActions('eventTracking', {
                $_saveQueryString: 'saveQueryString',
            }),

            getClassificationLink(classification) {
                const classificationLink = `${getSearchBaseUrl()}/cla_${classification.slug || slugify(classification.value)}/`;
                return classificationLink;
            },

            getSubClassificationLink(classification, subClassifiacation) {
                const subClassificationLink = `${getSearchBaseUrl()}/cla_${classification.slug || slugify(classification.value)}_scla_${subClassifiacation.slug || slugify(subClassifiacation.value) }/`;
                return subClassificationLink;
            },

            showCustomAttribute(index) {
                return window?.afConfig[`applyflow_custom_${index}_show`] === 'Yes' && this.$_job[`applyflow_custom_${index}_details`];
            },

            getCustomAttribute(index) {
                return window?.afConfig[`applyflow_custom_${index}_label`];
            },

            getCustomAttributeValue(index) {
                return this.$_job[`applyflow_custom_${index}_details`] ? this.$_job[`applyflow_custom_${index}_details`][0].value : '';
            },

        },

    };
</script>
